import React, { FC } from 'react';
import { CancelIcon, CheckCircleIcon } from '@ab-inbev-labs/ux-react-components';
import { getCssVariable } from '@ab-inbev/sam-utils';

type PermissionIconProps = {
  hasPermission?: boolean;
};

export const PermissionIcon: FC<PermissionIconProps> = ({ hasPermission }) => {
  return (
    <div>
      {hasPermission ? (
        <CheckCircleIcon color={getCssVariable('--color-feedback-positive-300')} />
      ) : (
        <CancelIcon color={getCssVariable('--color-feedback-danger-300')} />
      )}
    </div>
  );
};
